import { IconDefaultType as IconType } from "@slhuiicon/icon";

export const EVENT_CHECKBOX_CHANGE = "change";
export const SELECTED_ICO = IconType.ICO_CHECKBOX_SEL;
export const DESELECTED_ICO = IconType.ICO_CHECKBOX_DES;
export const INDETERMINATE_ICO = IconType.ICO_CHECKBOX_IND;
